import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LobbyWrapUpComponent } from './lobby-wrap-up.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { lobbyWrapUpReducer } from './state/lobby-wrap-up.reducer';
import { LobbyWrapUpEffects } from './state/lobby-wrap-up.effects';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ChipModule } from '@progress/kendo-angular-buttons';
import { CdTimerModule } from 'angular-cd-timer';
import { ClipboardModule } from 'ngx-clipboard';
import { LobbyWrapUpputFilterDirective } from './wrap-up-input-filter.directive';
import { AppTimerModule } from '../../shared/layout/app-layout/app-timer/app-timer.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    LobbyWrapUpComponent,
    LobbyWrapUpputFilterDirective
    
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    DialogModule,
    ChipModule,
    CdTimerModule,
    ClipboardModule,
    StoreModule.forFeature('lobbyWrapUp', lobbyWrapUpReducer),
    EffectsModule.forFeature([LobbyWrapUpEffects]),
    AppTimerModule,
    TranslateModule 
  ],
  exports: [
    LobbyWrapUpComponent,
    TranslateModule
  ],
})
export class LobbyWrapUpModule { }
